export default {
    footer: state => state.app.footer,
    isLoading: state => state.app.isLoading,
    token: state => state.app.token,
    isLogin: state => !!state.app.token,
    backgroundColor: state => state.app.backgroundColor,
    userInfo: state => state.app.userInfo || {},
    header: state => state.app.header,
    headerTitle: state => state.app.headerTitle
};
